import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

import "./NavBar.css";
import { IconContext } from "react-icons/lib";
import logo from "./images/CooMBaaH-Final-Logo.png";

function NavBar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closMobileMenue = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
    window.addEventListener("reSize", showButton);
    return () => window.removeEventListener("reSize", showButton);
  }, []);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <div className="navbar">
          <div className="navbar-container container">
            <Link to="/" className="navbar-logo" onClick={closMobileMenue}>
              <img
                className="navbar-icon"
                src={logo}
                style={{ height: 60, width: 60 }}
              />
              CooMBaaH
            </Link>

            <div className="menu-icon" onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>

            <ul className={click ? "nav-menu active" : "nav-menu"}>
              <li className="nav-item">
                <Link to="/" className="nav-links" onClick={closMobileMenue}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/music"
                  className="nav-links"
                  onClick={closMobileMenue}
                >
                  Music
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/Bookings"
                  className="nav-links"
                  onClick={closMobileMenue}
                >
                  Bookings
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </IconContext.Provider>
    </>
  );
}

export default NavBar;
